import { ChangeDetectionStrategy, Component, type InputSignal, input } from '@angular/core';
import { type ICountryPhoneMetaDto } from '@pecan/api';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-country-option',
    styleUrls: ['./country-option.component.scss'],
    templateUrl: './country-option.component.html',
})
export class CountryOptionComponent {
    public readonly country: InputSignal<ICountryPhoneMetaDto> = input.required<ICountryPhoneMetaDto>();
}
